import classes from './setor-select.module.css';
import React, {useEffect, useState} from "react";
import {Setor} from "../../../tipos/setor";
import SetorServico from "../../../servicos/setor-servico";
import {Box, Group, LoadingOverlay, Menu, MenuProps, Text, UnstyledButton} from "@mantine/core";
import {IconChevronDown, IconCircleDot} from "@tabler/icons-react";
import {COR} from "../../../config/constantes/constantes-mantine";

type SetStateFunction<T> = React.Dispatch<React.SetStateAction<T>>;

interface SetorSelectProps extends MenuProps {
  label?: string;
  setorInicial?: Setor;
  setorId: number;
  setSetorId: SetStateFunction<number>
}

export default function SetorSelect(props: SetorSelectProps) {

  const [isCarregando, setIsCarregando] = useState(false)
  const [opened, setOpened] = useState(false);
  const [setores, setSetores] = useState<Setor[]>([])
  const [selected, setSelected] = useState<Setor | undefined>(props.setorInicial);

  const semSetor: Setor = new Setor({id: 0, nome: "Sem setor selecionado", sigla: "N/A", cor: "gray"});
  const {label, setorInicial, setSetorId, setorId, ...restProps} = props
  const fetchSetores = async () => {
    setIsCarregando(true)
    const json = await SetorServico.buscarSetores().finally(() => setIsCarregando(false))
    json.push(semSetor)
    if (props.setorInicial) {
      setSelected(json.find(s => s.id === props.setorInicial?.id))
    } else setSelected(semSetor)
    setSetores(json)
  }

  useEffect(() => {
    fetchSetores()
  }, [props.setorInicial, props.setSetorId])

  return <Menu
    onOpen={() => setOpened(true)}
    onClose={() => setOpened(false)}
    radius="md"
    width="target"
    withinPortal
    {...restProps}
  >
    <Menu.Target>
      <div>
        <Text fw={700} size={"sm"} mb={10}>
          {props.label}
        </Text>
        <Box pos={"relative"}>
          <LoadingOverlay visible={isCarregando} zIndex={1000} overlayProps={{radius: "sm", blur: 0.5}}
                          loaderProps={{size: "sm", color: COR.PRIMARIO}}/>
          <UnstyledButton className={classes.control} data-expanded={opened || undefined}>
            <Group gap="xs">
              <IconCircleDot color={selected?.cor}/>
              <span className={classes.label}>{selected?.nome}</span>
            </Group>
            <IconChevronDown size={16} className={classes.icon} stroke={1.5}/>
          </UnstyledButton>
        </Box>
      </div>
    </Menu.Target>
    <Menu.Dropdown>
      {setores.map((s) => (
        <Menu.Item
          leftSection={<IconCircleDot color={s.cor}/>}
          onClick={() => {
            props.setSetorId(s.id!!)
            setSelected(s)
          }
          }
          key={s.id}
        >
          {s.nome}
        </Menu.Item>
      ))}
    </Menu.Dropdown>
  </Menu>
}